import {some} from 'lodash';

export default {
  motivatorsListState(state) {
    const KEY = 'leave_reasons';
    if (!state.profileOptions[KEY] || !state.motivatorsList.length) {
      return [];
    }
    return state.motivatorsList.map(value => state.profileOptions[KEY].find(option => option.slug === value));
  },
  motivatorsHasValuesState(state) {
    return some(state.motivatorsList);
  }
};
